export default __webpack_public_path__ + "static/media/dinoRiders2x.074d34e7.png";